import React from 'react';

function MessageInbound(props) {
  return (
    <svg version="1.1" viewBox="0 0 18 33" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1)" stroke="#909CAB" strokeWidth="1.2">
          <g transform="translate(0 15.736)">
            <polygon points="0 3.5577 0 12.715 7.9426 16.264 15.789 12.715 15.789 3.5577 7.9426 2.0314e-15" />
            <polyline points="0 3.5577 7.9426 7.1154 7.9426 16.264" />
            <line x1="7.8945" x2="15.789" y1="7.1154" y2="3.5577" />
          </g>
          <g transform="translate(7.9065 5.3971) scale(1 -1) translate(-3.9352 -5.3971)">
            <line x1="3.9713" x2="3.9713" y1="10.794" />
            <polyline points="0 3.825 3.9713 0 7.8704 3.825" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MessageInbound;
